import { IItems } from "../../../micro-apps/NotifyIfBack/helpers/types";
export const getNibOosItems = (variants) => {
    const filterOosVariants = variants === null || variants === void 0 ? void 0 : variants.filter((variant) => variant.stock.stockLevel === 0 && {
        value: variant.code,
        label: variant.size.name,
        isActive: variant.selected,
    });
    return filterOosVariants === null || filterOosVariants === void 0 ? void 0 : filterOosVariants.map((variant) => variant && {
        value: variant.code,
        label: variant.size.name,
        isActive: variant.selected,
    });
};
//# sourceMappingURL=getNibOosItems.js.map